import React, { Component } from 'react';
import { withRouter, Redirect } from "react-router-dom";

// Packages
import Select from 'react-select';
import 'react-select/dist/react-select.css';
import TextareaAutosize from 'react-autosize-textarea';
import MaskedTextInput from 'react-text-mask';

// API
import * as API  from '../../../../utils/api';

// Components
import Modal from '../Modal';

// Utils
import stateDataShortNames from '../../../../utils/stateDataShortNames.json';
import {
  convertCreditorsToArrayForSelectComponent,
  getStrippedDollarAmount,
  numberMask,
  isValidDate,
  validateEmail,
  showToast
} from '../../../../utils/helpers';

class AddOrganizationAccountModal extends Component {
  state = {
    input: {
      organizationInformation: {
        first_name: {
          value: "",
          hasError: false,
          isRequired: true,
        },
        email: {
          value: "",
          hasError: false,
          isRequired: true,
        },
        phone_number: {
          value: "",
          hasError: false,
          isRequired: false,
        },
        ssn: {
          value: "",
          hasError: false,
          isRequired: false,
        },
        street_address_primary: {
          value: "",
          hasError: false,
          isRequired: false,
        },
        street_address_secondary: {
          value: "",
          hasError: false,
          isRequired: false,
        },
        city: {
          value: "",
          hasError: false,
          isRequired: false,
        },
        state: {
          value: "",
          hasError: false,
          isRequired: false,
        },
        zipcode: {
          value: "",
          hasError: false,
          isRequired: false,
        },
      },
      debtInformation: {
        creditor_id: {
          value: "1",
          hasError: false,
          isRequired: false,
        },
        total_in_dollars: {
          value: "0.00",
          hasError: false,
          isRequired: false,
        },
        date_sent: {
          value: "",
          hasError: false,
          isRequired: false,
        },
        additional_details: {
          value: "",
          hasError: false,
          isRequired: false,
        },
      }
    },
    slide: 1,
    isLoading: true,
    error: {
      hasAnyError: false,
      statusCode: 200
    }
  }

  componentDidMount () {
    API.fetchAllCreditors(this.props.user).then(data => {

      let isAccessDenied =  (data && data.message && data.message == "Access denied.") ? true : false

      if (((typeof data != 'undefined') || (data != null)) && !data.error && !isAccessDenied) {
          const creditorsForSelectField = [...data.creditors];

          let creditorsArray = convertCreditorsToArrayForSelectComponent(creditorsForSelectField);
          this.setState(state => ({
            creditors: creditorsArray,
            isLoading: false
          }))
      }else{
          this.setState(state => ({
                ...state,
                error: {
                  hasAnyError: true,
                  statusCode: data ? (data.status || ((data.message && data.message == "Access denied.") ? 401 : 500) || 500) : 500
                }
          }))
      }
    });
  }

  handleModalClose = () => {
    this.props.hideModal();
    this.props.history.push("/admin/accounts");
  }

  handleOrganizationInfoInputChange(newPartialInput) {
    this.setState(state => ({
      ...state,
      input: {
        ...state.input,
        organizationInformation: {
          ...state.input.organizationInformation,
          ...newPartialInput,
        }
      }
    }))
  }

  handleCreditorInfoInputChange = (newPartialInput) => {
    this.setState(state => ({
      ...state,
      input: {
        ...state.input,
        debtInformation: {
          ...state.input.debtInformation,
          ...newPartialInput,
        }
      }
    }))
  }

  getNumberFromPhoneString = (phoneString) => {
    let strippedNumber = phoneString.replace(/\(|\)|\s|-/g, '');
    return strippedNumber;
  }

  toNextSlide = () => {
    /*this.scrollToTop();

    if(this.validateForm('organizationInfo')) {
      this.setState(state => ({
        ...state,
        slide: this.state.slide + 1
      }))
    } else {
      this.setFormErrorState('organizationInfo');
    }*/

  }

  toPreviousSlide = () => {
    /*this.setState(state => ({
      ...state,
      slide: this.state.slide - 1
    }))*/
  }

  handleSubmit = (event) => {
    event.preventDefault();

    const { input } = this.state;

    if(this.validateForm('organizationInfo')) {
     let organizationForSubmission = {
       first_name: input.organizationInformation.first_name.value,
       last_name: '.',//input.organizationInformation.last_name.value,
       email: input.organizationInformation.email.value,
       phone_number: this.getNumberFromPhoneString(input.organizationInformation.phone_number.value),
       //date_of_birth: input.organizationInformation.date_of_birth.value,
       ssn: '',//input.organizationInformation.ssn.value,
       street_address_primary: input.organizationInformation.street_address_primary.value,
       street_address_secondary: input.organizationInformation.street_address_secondary.value,
       city: input.organizationInformation.city.value,
       state: input.organizationInformation.state.value,
       zipcode: input.organizationInformation.zipcode.value,
       client_admin: true,
       debts_attributes: [
         {
           creditor_id: input.debtInformation.creditor_id.value,
           date_sent: input.debtInformation.date_sent.value,
           total_in_dollars: getStrippedDollarAmount(input.debtInformation.total_in_dollars.value).toFixed(2),
           additional_details: input.debtInformation.additional_details.value
         }
       ]
     }

     API.createOrganization(this.props.user, organizationForSubmission).then(data => {
       this.scrollToTop();
       if (((typeof data != 'undefined') || (data != null)) && !data.error) {
           if (data.message) {
            this.props.updateModalState(true, 'ERROR', {message: data.message});
           } else {
            let optionalProps = {
              account: organizationForSubmission
            }
            this.props.updateModalState(true, 'ACCOUNT_CREATED', optionalProps);
           }
       }else{
           this.setState(state => ({
                   ...state,
                   error: {
                    hasAnyError: true,
                    statusCode: data ? (data.status || ((data.message && data.message == "Access denied.") ? 401 : 500) || 500) : 500
                  }
           }))
       }
     });
    } else {
     this.setFormErrorState('organizationInfo');
    }
  }

  scrollToTop() {
    window.scrollTo(0, 0);
  }

  hasOnlyDigits = (string) => {
    return /^\d+$/.test(string);
  }

  validateForm = (formType) => {
    let errorsArePresent = false;

      // Determine which input group to check for errors
      let inputs =  formType === 'organizationInfo' ?
        {...this.state.input.organizationInformation}
        : {...this.state.input.debtInformation};

      // Check inputs for errors
      Object.entries(inputs).forEach(([key, value]) => {
        if (key === 'email') {
          if (!validateEmail(value.value) && value.value !== '') {
            errorsArePresent = true;
          }
        } else if (value.isRequired && value.value === '') {
          errorsArePresent = true;
        }
      });

    if (errorsArePresent) {
      return false;
    } else {
      return true;
    }
  }

  setFormErrorState = (formType) => {
    let errorsArePresent = false;

    // Determine which input group to check for errors
    let newInputState = formType === 'organizationInfo' ?
      {...this.state.input.organizationInformation}
      : {...this.state.input.debtInformation}

    // Set error state on necessary fields
    Object.entries(newInputState).forEach(([key, value]) => {
      if (key === 'email') {
        if (!validateEmail(value.value) && value.value !== '') {
          newInputState[key].hasError = true;
        }
      } else if (value.isRequired && value.value === '') {
        newInputState[key].hasError = true;
      }

      if (newInputState[key].hasError) {
        errorsArePresent = true
      }
    });

    if (formType === 'organizationInfo' && errorsArePresent) {
      this.setState(state => ({
        ...state,
        input: {
          ...state.input,
          organizationInformation: newInputState
        }
      }))
    } else if (formType === 'debtInfo' && errorsArePresent) {
      this.setState(state => ({
        ...state,
        input: {
          ...state.input,
          debtInformation: newInputState
        }
      }))
    }
  }

  renderErrorMessage(input) {
    let message = '';

    if (input === 'name') {
      message = "Please enter a Organization's name";
    } else if (input === 'email') {
      message = 'Please enter a valid email address';
    } else {
      message = 'Please complete this field';
    }

    return (
      <div className="input-error-message">
        {message}
      </div>
    )
  }

  render() {
    let { input, slide, creditors, error } = this.state;

    if (error.hasAnyError) {
      if (error.statusCode == 500) {
        showToast();
        this.setState({
          error:{
            ...this.state.error,
            hasAnyError: false,
            statusCode: 200
          }
        });
      } else if (error.statusCode == 401) {
        return <Redirect to={{ pathname: '/sign-out' }} />
      } else {
        this.props.updateModalState(true, 'OTHER_ERROR', true)
        return <Redirect to={{ pathname: '/sign-out' }} />
      }
    }

    return (
      <Modal
        optionalClasses="add-account-modal"
        title="Add Account"
        closeOnClickOutside={true}
        hideModal={this.props.hideModal}
      >
        <form
          className="admin-form"
        >
          <header className="modal-slide-header">
            <div className={`modal-slide-header-tab${slide === 1 ? ' active' : ''}`}>
              Organization's Information
            </div>
          </header>
          <div className={`modal-slide${slide === 1 ? '' : ' hide'}`}>
            <div className="form-container">
              <div className="form-column">
                <div
                  className={`input-container${input.organizationInformation.first_name.hasError ? ' error' : ''}`}
                >
                  <label htmlFor="name">Organization's Name</label>
                  <div
                    className="input-container multi-input-field"
                  >
                    <input
                      className="multi-input-field-input"
                      name="name"
                      type="text"
                      placeholder="Name"
                      value={input.organizationInformation.first_name.value}
                      onChange={event => this.handleOrganizationInfoInputChange({first_name: {value: event.target.value, hasError: false}})}
                    />
                  </div>
                  {input.organizationInformation.first_name.hasError ? this.renderErrorMessage('name') : null}
                </div>
                <div
                  className={`input-container${input.organizationInformation.email.hasError ? ' error' : ''}`}
                >
                  <label htmlFor="email">Organization's Admin Email Address</label>
                  <input
                    name="email"
                    type="email"
                    placeholder="address@email.com"
                    value={input.organizationInformation.email.value}
                    onChange={event => this.handleOrganizationInfoInputChange({email: {value: event.target.value, hasError: false}})}
                  />
                  {input.organizationInformation.email.hasError ? this.renderErrorMessage('email') : null}
                </div>
                <div
                  className={`input-container${input.organizationInformation.phone_number.hasError ? ' error' : ''}`}
                >
                  <label htmlFor="phone">Organization's Phone Number</label>
                  <MaskedTextInput
                    name="phone"
                    mask={['(', /\d/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]}
                    placeholder="(555) 555-5555"
                    placeholderChar={'\u2000'}
                    guide={true}
                    type="text"
                    value={input.organizationInformation.phone_number.value}
                    onChange={event => this.handleOrganizationInfoInputChange({phone_number: {value: event.target.value, hasError: false}})}
                  />
                </div>
                
              </div>
              <div className="form-column">
                <div
                  className={`input-container${input.organizationInformation.street_address_primary.hasError ? ' error' : ''}`}
                >
                  <label htmlFor="streetAddress">Street Address</label>
                  <input
                    name="streetAddress"
                    type="text"
                    placeholder="Enter an Address"
                    value={input.organizationInformation.street_address_primary.value}
                    onChange={event => this.handleOrganizationInfoInputChange({street_address_primary: {value: event.target.value, hasError: false}})}
                  />
                  {input.organizationInformation.street_address_primary.hasError ? this.renderErrorMessage() : null}
                </div>
                <div
                  className={`input-container${input.organizationInformation.street_address_secondary.hasError ? ' error' : ''}`}
                >
                  <label htmlFor="unit">Apt #</label>
                  <input
                    name="unit"
                    type="text"
                    placeholder="Apt. #"
                    value={input.organizationInformation.street_address_secondary.value}
                    onChange={event => this.handleOrganizationInfoInputChange({street_address_secondary: {value: event.target.value, hasError: false}})}
                  />
                  {input.organizationInformation.street_address_secondary.hasError ? this.renderErrorMessage() : null}
                </div>
                <div className="city-state-container">
                  <div
                    className={`input-container${input.organizationInformation.city.hasError ? ' error' : ''}`}
                  >
                    <label htmlFor="city">City</label>
                    <input
                      name="city"
                      type="text"
                      placeholder="Enter a City"
                      value={input.organizationInformation.city.value}
                      onChange={event => this.handleOrganizationInfoInputChange({city: {value: event.target.value, hasError: false}})}
                    />
                    {input.organizationInformation.city.hasError ? this.renderErrorMessage() : null}
                  </div>
                  <div
                    className={`input-container${input.organizationInformation.state.hasError ? ' error' : ''}`}
                  >
                    <label htmlFor="state">State</label>
                    <Select
                      inputProps={{autoComplete: 'none', autoCorrect: 'off', spellCheck: 'off' }}
                      className="form-select"
                      name="state"
                      value={input.organizationInformation.state.value}
                      placeholder=""
                      options={stateDataShortNames}
                      resetValue=""
                      onChange={event => this.handleOrganizationInfoInputChange({
                        state: {value: event.value, hasError: false}}
                      )}
                    />
                    {input.organizationInformation.state.hasError ? this.renderErrorMessage() : null}
                  </div>
                </div>
                <div
                  className={`input-container${input.organizationInformation.zipcode.hasError ? ' error' : ''}`}
                >
                  <label htmlFor="zipcode">Zip Code</label>
                  <MaskedTextInput
                    guide={true}
                    mask={[/\d/, /\d/, /\d/, /\d/, /\d/]}
                    name="zipcode"
                    placeholder="90210"
                    placeholderChar={'\u2000'}
                    type="text"
                    value={input.organizationInformation.zipcode.value}
                    onChange={event => this.handleOrganizationInfoInputChange({zipcode: {value: event.target.value, hasError: false}})}
                  />
                  {input.organizationInformation.zipcode.hasError ? this.renderErrorMessage() : null}
                </div>
              </div>
            </div>
            <div className="modal-actions">
              <a
	            className="cta"
	            onClick={(event) => this.handleSubmit(event)}
	          >
	            Add Account »
	          </a>
              <a
                className="modal-link"
                onClick={this.props.hideModal}
              >
                Cancel
              </a>
            </div>
          </div>
        </form>
      </Modal>
    )
  }
}

export default withRouter(AddOrganizationAccountModal);
